export default __webpack_public_path__ + "static/media/Dimitri.ba729600.jpg";